var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupplyChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3AC6B5",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0018 12.8623H19.1348V14.9822H23.0843L22.001 13.3861C21.7784 13.0581 21.4049 12.8623 21.0018 12.8623Z",
    fill: "#3AC6B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7472 15.7624H18.7352C18.5145 15.7624 18.3357 15.5878 18.3357 15.3725V12.1789C18.3357 11.534 17.798 11.0093 17.1371 11.0093H7.18262V19.8099H8.12245C8.318 18.7108 9.30174 17.8722 10.4831 17.8722C11.6644 17.8722 12.6481 18.7108 12.8437 19.8099H18.6525C18.8481 18.7108 19.8318 17.8722 21.0131 17.8722C22.1944 17.8722 23.1781 18.7108 23.3737 19.8099H24.8183V17.2674C24.8183 16.9515 24.6847 16.6446 24.4517 16.4254L23.7472 15.7624Z",
    fill: "#3AC6B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7393 21.7501C11.6102 21.6122 12.2017 20.8113 12.0603 19.9613C11.919 19.1114 11.0983 18.5341 10.2274 18.6721C9.35644 18.81 8.76497 19.6109 8.90632 20.4609C9.04767 21.3109 9.8683 21.8881 10.7393 21.7501Z",
    fill: "#3AC6B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0136 21.7706C21.8959 21.7706 22.6112 21.0725 22.6112 20.2115C22.6112 19.3504 21.8959 18.6523 21.0136 18.6523C20.1313 18.6523 19.416 19.3504 19.416 20.2115C19.416 21.0725 20.1313 21.7706 21.0136 21.7706Z",
    fill: "#3AC6B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyChain);
export default __webpack_public_path__ + "static/media/Supply-chain.58b88a4a.svg";
export { ForwardRef as ReactComponent };